/* global axios */

const AutomationExecutionsAPI = {
  index(accountId, params = {}) {
    return axios.get(`/api/v1/accounts/${accountId}/automation_executions`, {
      params,
    });
  },

  show(accountId, id) {
    return axios.get(
      `/api/v1/accounts/${accountId}/automation_executions/${id}`
    );
  },
};

export default AutomationExecutionsAPI;
